import type { CmsContext } from '@eneco/cms-adapter';

import { useCms } from './provider';

/**
 * The CMS-agnostic equivalent of Sitecore's `useLayoutData()`. Returns page
 * context (locale, path, customer/experiment info) — never component content.
 */
export const useLayoutData = (): CmsContext => useCms().page.context;
